const DpoCoreZmenaUzivatele = {
    init: function () {
        $(document)
            .on("modal.button.miniform.close.pre", function (e, data) {
                if (data.hasOwnProperty("miniformId")) {
                    if (106 === parseInt(data["miniformId"])) {
                        const modalUzivatelId = $("#modal-uzivatel").val();
                        const modalUzivatelAutocomplete = $("#modal-uzivatelAutocomplete").val();

                        if (modalUzivatelId) {
                            let url = window.location.protocol + "//" + window.location.host;
                            url += "/ajax/core/zmenaUzivatele";

                            const sekceId = $('#idSection').val();
                            if (!sekceId) {
                                return;
                            }
                            url += '/' + sekceId;

                            const zadostId = $('#idItem').val();
                            if (!zadostId) {
                                return;
                            }
                            url += '/' + zadostId;

                            let komentar = null;
                            let odeslatEmail = false;
                            if (true === $("#modal-odeslatemail").prop("checked")) {
                                odeslatEmail = true;
                                komentar = $("#modal-komentar").val();
                                if ('' === komentar) {
                                    komentar = null;
                                }
                            }

                            $.ajax({
                                type: "post",
                                url: url,
                                data: {"uzivatelId": modalUzivatelId, "odeslatEmail": odeslatEmail, "komentar": komentar, "_ch": $("#_ch").val()},
                                dataType: "json",
                                global: true,
                                beforeSend: function () {
                                    Lemo_Alert.closeAll();
                                },
                                complete: function () {
                                    DynaCore_Item.miniformReload(103, 4);
                                },
                                success: function (r) {
                                    if (r.hasOwnProperty("messages")) {
                                        Lemo_Alert.addMany(r["messages"]);
                                    }
                                    if (true === r.status) {
                                        $("#uzivatel").val(modalUzivatelId);
                                        $("#uzivatelAutocomplete").val(modalUzivatelAutocomplete);
                                    }
                                },
                                error: function () {
                                    Lemo_Alert.addDanger("Změna uživatele selhala.", "zmenaUzivateleError");
                                }
                            });
                        }
                    }
                }
            });
    }
}

$(document).ready(function () {
    DpoCoreZmenaUzivatele.init();
});